import {Dayjs} from 'dayjs';
import {conditions, TABLE_KEYS} from './constants';
import {ICommentList, IMetadataFieldList} from '../api/types/document.type';

export type ArrDatePickerType =
  | 'date-picker'
  | 'date-range-picker'
  | 'query-date-picker';

export type Condition = (typeof conditions)[number];

export type SelectedDateType = Dayjs | null;

export type RightPanelProps = {
  side: 'right' | 'left';
  size: 'small' | 'large';
};

export interface ISelectItem {
  value?: string | number;
  label?: string | number;
  id?: string | number;
  name?: string | number;
  disabled?: boolean;
  isDefault?: boolean;
  trainingSetType?: string;
  [key: string]: string | number | boolean | undefined | null;
}

export interface ICheckboxListItem {
  label: string;
  value: boolean;
}

export interface GroupedItem {
  groupName: string;
  items: {id: string | number; label: string; disabled?: boolean}[];
}

export type Role = {
  id: number;
  name: string;
  encryptedID: string;
};

export type ProjectOption = {
  projectId: number;
  value: string;
  isSelected: boolean;
  text: string | null;
};

export interface ISecurityGroup {
  Disabled: boolean;
  Group: string | null;
  Selected: boolean;
  Text: string;
  Value: string;
}
export interface Reviewer {
  name: string;
  distributed: number;
  completed: number;
  todo: number;
}
export interface ReviewerProgress {
  key: keyof typeof TABLE_KEYS;
  label: string;
}

export type RoleOption =
  | 'System Administrator'
  | 'Domain Administrator'
  | 'Project Administrator'
  | 'Review Manager'
  | 'Reviewer';

export type AnyResult = {
  securityGroupID?: number;
  parentID?: number;
  isGroup?: boolean;
  count?: number;
  propagationToFamily?: boolean;
  propagationToDuplicates?: boolean;
  propagationToEmailThreads?: boolean;
  propagationToEmailDuplicates?: boolean;
  masterDocListID?: number;
  classificationID?: number;
  classification?: string;
  isSelected?: boolean;
  isAIEnabled?: boolean;
  showAIHints?: boolean;
  calModelID?: number;
  projectFieldID?: number;
  projectFieldNameCode?: string;
  projectFieldName?: string;
  projectFieldDatatype?: string;
  projectFieldDataTypeLengthCode?: string;
  projectFieldDataTypeControl?: string;
  projectFieldMaxLength?: number;
  projectFieldMinValue?: string;
  projectFieldMaxValue?: string;
  projectFieldSplitLength?: number;
  commentId?: number;
  securityGroupId?: number;
  parentId?: number;
  isLocked?: boolean;
  isDeleted?: boolean;
  createdBy?: number;
  modifiedBy?: number;
  createdOn?: string;
  modifiedOn?: string;
  commentLabel?: string;
  roleid?: number;
  projectID?: number;
  loggedInUserId?: number;
  rowNumber?: number;
  isCommentEdited?: boolean;
  disabled?: boolean;
  id?: string | number;
  name?: string;
  type?: string;
  sysLabel?: string;
  value?: string | number;
  friendlyLabel?: string;
};

export type FieldLogicArray = {
  objectname: string;
  condition: string;
  operator: string;
};

export type CodingFormItem = {
  projectFieldName?: string;
  projectFieldDatatype?: string;
  aiPredictionClassification?: string;
  aiPredictionScore?: number;
  contextType?: string;
  systemControlName?: string;
  customControlLabel?: string;
  groupControlName?: string;
  controlLogicJSon?: {
    objectname: string;
    condition: string;
    operator: string;
  }[];
  id: number;
  cfItemID: number;
  sequence: number;
  type: string;
  specialFlag: boolean;
  value: string;
  systemLabel: string;
  friendlyLabel?: string;
  logicRuleCount: string;
  tagType: string;
  errorMessage: string;
  defaultAction: string;
  helpText: string;
  fieldLogic: FieldLogicArray[];
  fieldLogicJson: string;
  fieldLogicAction: string;
  fieldLogicObjectLabel: string;
  //groupAssociation: string;

  groupAssociation: ISelectItem | null;
  metaDataType?: string;
  maxLength?: number;
  minValue?: string;
  maxValue?: string;
  splitLength?: number;
  dataTypeLengthCode?: string;
  isCollapsed?: boolean;
  displayType?: string; // Added to match API response
  controlValue?: string;
};

export type Id = number | string;

export type CommentResult = ICommentList & {
  type: 'comment';
  sysLabel: string;
  value: number;
  friendlyLabel: string;
};

export type MetaResult = IMetadataFieldList & {
  type: 'field';
  sysLabel: string;
  value: number;
  friendlyLabel: string;
};

export type OtherItem = {
  id: number | string;
  type: string;
  label: string;
};
export type OtherResult = OtherItem & {
  sysLabel: string;
  value: string;
  friendlyLabel: string;
};
export interface SummaryStats {
  mappedIngests: number;
  uniqueIngests: number;
}

export interface ManageColumnTabProps {
  label?: string;
  disabled: boolean;
  isLoading: boolean;
  content: React.ReactNode;
  icon?: React.ReactNode;
}

export interface TagNode {
  id: string;
  label: string;
  children?: TagNode[];
}

export type A11yStatusProps = {
  role?: 'status' | 'alert' | 'progressbar';
  ariaLive?: 'polite' | 'assertive' | 'off';
  ariaAtomic?: boolean;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  ariaValueNow?: number;
  ariaValueMin?: number;
  ariaValueMax?: number;
};

export enum DOC_TYPE_MAPPING_FOR_AI_REVIEW_JOB {
  ALL = 'all',
  COMPLETED = 'completed',
  EXCLUDED = 'excluded',
  RELEVANT = 'relevant',
  NON_RELEVANT = 'nonrelevant',
}
